import { useApp } from '../../context/AppContext';

/** Bottom toast, driven by AppContext's showToast(). Mounted once in App. */
export default function Toast() {
  const { toast } = useApp();
  return <div className={`toast${toast.visible ? ' show' : ''}`}>{toast.message}</div>;
}
